import React from 'react';
import { useTranslation } from 'react-i18next';
import SystemNotification from '../../../../SystemNotification/SystemNotification';
import { Notification, NotificationQueueItem } from '../../../../Notifications';

interface Props extends NotificationQueueItem {
  deviationIds?: number[];
  folderName?: string;
  label: 'aiGenerated' | 'noAi';
  value: boolean;
}

const LabelAsNotification: React.FC<Props> = ({
  id,
  queueName,
  deviationIds,
  folderName,
  label,
  value,
}) => {
  const { t } = useTranslation();
  const labelName = t(`mediapopup.notifications.labelAs.label.${label}`);

  return (
    <Notification
      id={id}
      queueName={queueName}
      cardComponent={SystemNotification}
      cardProps={{ limitTextWidth: false }}
    >
      {t(
        `mediapopup.notifications.labelAs.${
          deviationIds && deviationIds.length
            ? 'selectedDeviations'
            : 'selectedFolder'
        }.value.${value}`,
        { labelName, folderName }
      )}
    </Notification>
  );
};
LabelAsNotification.displayName = 'LabelAsNotification';

export default LabelAsNotification;
